var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgProfilefull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.68457,
    width: 30,
    height: 30,
    rx: 15,
    fill: "#F6F3F7"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_649_23591)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4209 21.5795C10.4209 20.1836 10.9754 18.8449 11.9624 17.8578C12.9495 16.8708 14.2882 16.3163 15.6841 16.3163C17.0799 16.3163 18.4186 16.8708 19.4057 17.8578C20.3927 18.8449 20.9472 20.1836 20.9472 21.5795H19.6314C19.6314 20.5326 19.2155 19.5285 18.4753 18.7883C17.735 18.048 16.731 17.6321 15.6841 17.6321C14.6371 17.6321 13.6331 18.048 12.8928 18.7883C12.1526 19.5285 11.7367 20.5326 11.7367 21.5795H10.4209ZM15.6841 15.6584C13.5031 15.6584 11.7367 13.892 11.7367 11.711C11.7367 9.53012 13.5031 7.76367 15.6841 7.76367C17.865 7.76367 19.6314 9.53012 19.6314 11.711C19.6314 13.892 17.865 15.6584 15.6841 15.6584ZM15.6841 14.3426C17.138 14.3426 18.3156 13.165 18.3156 11.711C18.3156 10.2571 17.138 9.07946 15.6841 9.07946C14.2301 9.07946 13.0525 10.2571 13.0525 11.711C13.0525 13.165 14.2301 14.3426 15.6841 14.3426Z",
    fill: "#003636"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_649_23591"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.7895,
    height: 15.7895,
    fill: "white",
    transform: "translate(7.79004 7.10547)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilefull);
export default __webpack_public_path__ + "static/media/profilefull.6bf9e3fc0bc758720f66745a798327bd.svg";
export { ForwardRef as ReactComponent };